export const OnFooterClick = (centerId: string) => {
  const url = `/robot/1?centerId=${centerId}`;
  window.parent.location.href = url;
};
